












































import { defineComponent, computed } from '@nuxtjs/composition-api'
import uniqueid from 'lodash.uniqueid'

export default defineComponent({
  name: 'BlocksSliderBannerCard',

  inheritAttrs: false,

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },

  setup(props) {
    const uid = uniqueid('uid-')

    const banners = computed(() =>
      props.data?.Banners?.map((banner: any) => ({
        id: banner.ID,
        imageUrl: banner.ImageUrl,
        alternateUrl: banner.AlternateUrl,
        title: banner.Heading || banner.Title,
        text: banner.Text,
        linkTitle: banner.LinkTitle
      }))
    )

    const swiperOptions = computed(() => {
      return {
      slidesPerView: 2.5,
      spaceBetween: 8,
      lazy: {
        loadPrevNext: true,
      },
      breakpoints: {
        481: {
          slidesPerView: 3.5,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4.5,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 6.5,
        },
        1550: {
          slidesPerView: 8,
        },
      },
    }
    })

    return {
      uid,
      swiperOptions,
      banners,
    }
  },
})
